

export default function(to, from) {
  // console.log(to, from);
  var uuid='';

  if(to.name == "VideoName"){
    uuid = to.params.uuid;
  }
  if(to.name !== 'Detail'){//detail埋码在detail.vue页面

    var q = (window.goldlog_queue || (window.goldlog_queue = []));
    // q.push({
    //   action: 'goldlog.setPageSPM',
    //   arguments: ['spmA', 'spmB']
    // });
    q.push({
      action: 'goldlog.sendPV',
      arguments: [
    // 必填的配置项
    {
        is_auto: false
      },
    // 可选的自定义参数
    {
        uuid: uuid,
        ch_id: 'EPGC1386744804340101',
        col_id: 'EPGM1387361853673102',
      }]
    });
  }

  //百度统计
  var _hmt = (window._hmt || (window._hmt=[]));
  _hmt.push(['_trackPageview', to.fullPath]);

}



// WEBPACK FOOTER //
// ./src/statistic/index.js